import { BizPrintBarcode } from 'src/components/biz-print-barcode';

export default BizPrintBarcode;
